import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import ProChiose from "@/components/pro-common/pro-chiose-modal/pro-chiose.vue";
import { modMemberDepartmentBatch } from "@/service/structure";
export default {
  name: "member-batch-add",
  components: {
    ProChiose
  },
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      styles: {
        height: "calc(100% - 50px)",
        overflow: "scroll",
        paddingBottom: "40px",
        position: "static"
      },
      loading: false,
      memberCheckedList: [],
      departmemtCheckedList: []
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    isMobile() {
      return window.innerWidth < 768;
    },
    _userIds() {
      return this.memberCheckedList.map(v => v.userId).join(",");
    },
    _orgIds() {
      return this.departmemtCheckedList.map(v => v.orgId).join(",");
    }
  },
  methods: {
    close() {
      this.memberCheckedList = [];
      this.departmemtCheckedList = [];
      this.visible = false;
    },
    onOpenMember() {
      this.member.visible = true;
    },
    onOpenDepartMemt() {
      this.departmemt.visible = true;
    },
    onChangeMember(list) {
      this.memberCheckedList = list;
    },
    onChangeDepartmemt(list) {
      this.departmemtCheckedList = list;
    },
    async onSubmit() {
      const params = {
        userIds: this._userIds,
        orgIds: this._orgIds
      };
      this.loading = true;
      let {
        data
      } = await modMemberDepartmentBatch(params);
      this.loading = false;
      if (data && data.result === 0) {
        // lg: 保存成功
        this.$Message.success($t("aghf564", "保存成功"));
        this.$emit("onSuccess");
        this.close();
      }
    }
  }
};